// import * as S3 from "./s3";
import * as S3 from "./uppy"; // hack until we figure out why we are seeing issues with ^
export type { UploadSource, ContentDisposition } from "./shared";
export { buildPresignedPostForm } from "./shared";

export const uploadTo = {
  s3: S3.uploadFiles,
};
